import React from "react";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { DialogTitle, CircularProgress } from "@material-ui/core";
import { compose } from "recompose";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import TrailerHook from "../TrailerHook";
import TrailerDrop from "../TrailerDrop";
import { Drop_Hook_Move_Page_Names } from "../../constants";
import { getPageDetails } from "../utils";
import MoveBills from "../MoveBills";
import styles from "./styles";
import { withTrailerHOC } from "../../../Common/withTrailerHOC";
import { observer, inject } from "mobx-react";

@inject("DispatchStore")
@observer
class DropHookMoveDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      pageName: Drop_Hook_Move_Page_Names.DROP_HOOK_MOVE,
    };
  }

  showHideLoader = (value) => {
    this.setState({
      showLoader: value,
    });
  };

  setPageName = (pageName) => {
    this.setState({
      pageName,
    });
  };

  handleBack = () => {
    this.setState({
      pageName: Drop_Hook_Move_Page_Names.DROP_HOOK_MOVE,
    });
  };

  onClose = () => {
    if (this.state.showLoader) {
      return;
    }
    this.setState({
      pageName: Drop_Hook_Move_Page_Names.DROP_HOOK_MOVE,
    });
    this.props.handleClose();
  };

  render() {
    const { classes, open, routeData, currentDriverRoutes } = this.props;
    const { theme } = this.props.userData.userProfile || {};
    const { showLoader, pageName } = this.state;
    const { isDropHookPage, isTrailerDropFormPage, isSelectShipmentPage } =
      getPageDetails(pageName);
    const clientCodes = this.props.DispatchStore.getStaticClientData().clientCodes
    return (
      <React.Fragment>
        <Dialog
          aria-labelledby="drop-hook-move-title"
          open={open}
          classes={{ paper: classes.dialog }}
          className={`${classes.dialogWrapper} ${
            theme === "dark" ? "darkTheme" : "lightTheme"
          } `}
        >
          <DialogTitle
            disableTypography
            handleClose={this.onClose}
            id="drop-hook-move-title"
            classes={{ root: classes.dialogTitle }}
          >
            <span className={classes.dialogTitleText}>
              {!isDropHookPage ? (
                <IconButton
                  aria-label="close"
                  className={classes.backButton}
                  onClick={this.handleBack}
                >
                  <ArrowBack />
                </IconButton>
              ) : null}
              {pageName}
            </span>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={this.onClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className={`customScroll ${classes.dialogContent}`}>
            {isDropHookPage || isTrailerDropFormPage ? (
              <TrailerDrop
                routeData={routeData}
                currentDriverRoutes={currentDriverRoutes}
                isTrailerDropFormPage={isTrailerDropFormPage}
                setPageName={this.setPageName}
                showHideLoader={this.showHideLoader}
                isLoading={showLoader}
              />
            ) : null}
            {isDropHookPage ? (
              <TrailerHook
                routeData={routeData}
                currentDriverRoutes={currentDriverRoutes}
                showHideLoader={this.showHideLoader}
                isLoading={showLoader}
                trailerList={this.props.trailerList ?? []}
                maxAllowedTrailerCount={clientCodes.maxAllowedTrailerCount}
                allowedTrailerStatusesToHook={
                  clientCodes.allowedTrailerStatusesToHook
                }
              />
            ) : null}
            {(isDropHookPage || isSelectShipmentPage) && (
              <MoveBills
                userProfile={this.props.userData.userProfile}
                routeData={routeData}
                currentDriverRoutes={currentDriverRoutes}
                isSectionDisabled={!currentDriverRoutes.length}
                isSelectShipmentPage={isSelectShipmentPage}
                setPageName={this.setPageName}
                onClose={this.props.handleClose}
                trailerList={this.props.trailerList ?? []}
                allowedTrailerStatusesToMoveBills={
                  clientCodes.allowedTrailerStatusesToMoveBills
                }
              />
            )}
          </DialogContent>
          {showLoader ? (
            <div className={classes.loader}>
              <CircularProgress size={30} />
            </div>
          ) : null}
        </Dialog>
      </React.Fragment>
    );
  }
}

export default compose(withUserProfile, withStyles(styles))(withTrailerHOC(DropHookMoveDialog));
